import axios from 'axios';
import withResolve from '@cdglib/js-resolve-style'

const get = async (payload) => {
    const url = () => axios.get(`https://stat.bora.dopa.go.th/statusNTH/connectAPI/php_forward.php?API=${payload}`)
    // const url = () => axios.get(`${payload}`, {
    //     headers: {
    //         'Authorization': process.env.VUE_APP_AUTHORIZATION,
    //     }
    // })
    const [error, result] = await withResolve(url)()
    if (error) return { error }

    return { error, data: result.data }
}

export default { get }